import React, { useState, useEffect, useContext, useRef } from "react";
import styles from "./PackageDetail.module.css";
import IndicatorLabel from "../IndicatorLabel/IndicatorLabel";
import df from "../../utils/dateFormater";
import { TiDocumentText } from "react-icons/ti";
import PersonIcon from "@material-ui/icons/Person";
import { Tooltip } from "@material-ui/core";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import biologicalImg from "../../assets/images/BIOLOGICO.svg";
import chemicalImg from "../../assets/images/QUIMICO.svg";
import materialImg from "../../components/NavBar/Menu/icons/INSTRUMENTS.svg";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import { CiTimer } from "react-icons/ci";
import t from "../../utils/translation";
import { IoReload } from "react-icons/io5";
import { FaTemperatureHigh } from "react-icons/fa";
import request from "../../utils/request";
import ImageModal from "../../components/ImageModal/ImageModal";
import ButtonQ from "../ButtonQ";
import ReportModal from "../ReportModal/ReportModal";
import ModalLoading from "../ModalLoading/ModalLoading";
import LocalizationContext from "../../utils/LocalizationContext";
import Redirect from "../../utils/Redirect";
import PageContainer from "../PageContainer/PageContainer";
import hasPositive from "../../utils/hasPositive";

import toStartIcon from "../../assets/images/Icono To start.svg";
import inProgressIcon from "../../assets/images/Icono In progress.svg";
import finishedIcon from "../../assets/images/Icono Finished.svg";
import minutesToHourFormat from "../../utils/minutesToHours";
import BatchRecordPdf from "../PackageWashingDetail/BatchRecordPdf";
import ReactDOM from "react-dom";

import * as htmlToImage from "html-to-image";
import { print } from "react-html2pdf";
import ObservationCard from "../ObservationCard/ObservationCard";

export default function BatchRecordDetail({ params, location }) {
  const [isModalOpen, setModalOpen] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [openSections, setOpenSections] = useState({});
  const [report, setReport] = useState({});
  const [showReport, setShowReport] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cycleDetail, setCycleDetail] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const locale = useContext(LocalizationContext);
  const [showIconTerra, setShowIconTerra] = useState(false);

  const generatePDF = async () => {
    setShowIconTerra(true);
    const marginTop = 10;
    const marginBottom = 10;
    if (!cycleDetail || !cycleDetail.packages) return;

    // let allSections = {};
    // cycleDetail.packages.forEach(pkg => {
    //     allSections[pkg.package.id] = true;
    // });

    // setOpenSections(allSections);

    await new Promise((resolve) => setTimeout(resolve, 500));

    const element = document.getElementById("report-content");

    try {
      const dataUrl = await htmlToImage.toJpeg(element, {
        quality: 1,
        backgroundColor: "white",
        useCORS: true,
      });

      const img = new Image();
      img.src = dataUrl;

      img.onload = function () {
        const imgWidth = 210 - 20; // Reducimos el ancho para el padding (10mm en cada lado)
        const pageHeight = 297 - 20; // Reducimos la altura para el

        const imgRatio = img.width / img.height;
        const imgHeight = imgWidth / imgRatio;

        const pdf = new jsPDF({
          orientation: imgHeight > pageHeight ? "portrait" : "portrait",
          unit: "mm",
          format: "a4",
        });

        let y = 0;
        while (y < img.height) {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.width = img.width;
          canvas.height = pageHeight * (img.width / imgWidth);

          ctx.fillStyle = "white";
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          const offsetX = (canvas.width - img.width) / 2;

          ctx.drawImage(img, offsetX, -y, img.width, img.height);

          const chunkDataUrl = canvas.toDataURL("image/jpeg", 1.0);

          if (y > 0) pdf.addPage();
          pdf.addImage(chunkDataUrl, "JPEG", 10, 10, imgWidth, pageHeight);

          y += canvas.height;
        }

        pdf.save("report.pdf");
      };
    } catch (error) {
      console.error("Error al generar el PDF:", error);
    } finally {
      setShowIconTerra(false);
    }

    // htmlToImage.toJpeg(document.getElementById('report-content'), {
    //     quality: 0.95,
    //     backgroundColor: 'white',
    //     useCORS: true
    // })
    // .then(dataUrl => {
    //     console.log("Descargando archivo...");
    //     var link = document.createElement('a');
    //     link.download = 'report.jpeg';
    //     link.href = dataUrl;
    //     link.click();
    // })
    // .catch(err => {
    //     console.error("Error al generar la imagen:", err);
    // });
  };

  const { cycleId } = params;
  const { state } = location;
  const handleShowDetail = () => {
    setShowDetail(true);
  };

  const handleImageClick = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleCloseModalReport = () => {
    setShowReport(false);
    setShowIconTerra(false);
  };

  const toggleOpen = (id) => {
    setOpenSections((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const getResultText = (result) => {
    switch (result) {
      case 1:
        return t("PositiveSpan");
      case 2:
        return t("NegativeSpan");
      case 3:
        return t("CanceledSpan");
      default:
        return "";
    }
  };

  const getLoadDetail = async () => {
    setModalLoading(true);
    try {
      await request()
        .get(`/api/Charge/chargedto?chargeId=${cycleId}`)
        .then((response) => {
          const data = response.data;
          setCycleDetail(data);
        });
    } catch {
    } finally {
      setModalLoading(false);
    }
  };

  const status = (value) => {
    return value === 2
      ? t("ToStartSpan", locale) || "To Start"
      : value === 3
      ? t("StartedSpan", locale) || "Started"
      : value === 9
      ? t("BlankEntry126", locale) || "Released"
      : value === 10
      ? t("BlankEntry127", locale) || "Rejected"
      : value === 11
      ? t("BlankEntry128", locale) || "Partially Released"
      : value === 4
      ? t("FinishedSpan", locale) || "Finished"
      : "";
  };

  const findImg = (value) => {
    return value === 2
      ? toStartIcon
      : value === 3
      ? inProgressIcon
      : finishedIcon;
  };

  const statusPackage = (packageValue) => {
    switch (packageValue) {
      case 7:
        return t("BlankEntry127", locale) || "Rejected";
      case 8:
        return t("BlankEntry239", locale) || "Rejected in Area";
      case 9:
        return t("BlankEntry240", locale) || "Accepted in Area";
      case 10:
        return t("BlankEntry196", locale) || "Dispatched";
      case 11:
        return t("BlankEntry200", locale) || "Missing";
      case 12:
        return t("BlankEntry241", locale) || "Reception Completed";
      case 13:
        return t("BlankEntry242", locale) || "Reception Partial";
      default:
        return t("BlankEntry126", locale) || "Released";
    }
  };

  useEffect(() => {
    getLoadDetail();
  }, []);

  return (
    <PageContainer
      categoryId={1}
      category={t("SterilizationSpan")}
      backUrl={"/appsterilization"}
      title={t("BatchRecordSpan")}
      subtitle={t("DetailSpan")}
      clickBack={true}
      onClickBack={() =>
        Redirect({
          redirect: true,
          path:
            state?.packageRecord && state?.storage === false
              ? `/appconsultpackage`
              : state?.cycleRecord
              ? `/appcyclerecord`
              : state?.materialRecord
              ? `/appmaterialtracking`
              : state?.packageRecord && state?.storage === true
              ? `/appstorage`
              : state?.packageRecord && state.release === true
              ? `/appreleasecycle`
              : state?.packageRecord && state.dispatch === true
              ? `/apppackagedispatch`
              : `/appmanagecycles`,
          parameters: {
            cycleId: !state?.cycleRecord ? cycleId : null,
            packageId: state?.packageId ?? null,
          },
        })
      }
    >
      <div className={styles.container} id="report-content">
        {showIconTerra && (
          <div className={styles.imageContainer}>
            <img
              className={styles.iconTerra}
              src={"/../../images/logotipoverde.png"}
            />
          </div>
        )}
        <ModalLoading open={modalLoading} />
        <div className={styles.header}>
          <div className={styles.headerTitleContainer}>
            <p className={styles.title}>
              {cycleDetail.chargeStatus === 4 && (
                <Tooltip
                  title={
                    <span>{` ${
                      hasPositive(cycleDetail.indicators)
                        ? t("BlankEntry18")
                        : t("BlankEntry19")
                    }`}</span>
                  }
                  arrow
                >
                  <div
                    className={`${styles.hasPositive} ${
                      hasPositive(cycleDetail.indicators)
                        ? styles.red
                        : cycleDetail.indicators.some(
                            (i) => !i.readingBi && !i.readingCheSterilizer
                          )
                        ? styles.gray
                        : styles.green
                    }`}
                  ></div>
                </Tooltip>
              )}
              {`${t("CycleNumberSpan", locale) || "Cycle Number"}: ${
                cycleDetail.cicleNumber ?? ""
              }`}
            </p>

            <div className={styles.detailItem}>
              <div className={styles.detailItem} style={{ gap: "10px" }}>
                <img
                  className={styles.iconImg}
                  alt={status(cycleDetail.chargeStatus)}
                  src={findImg(cycleDetail.chargeStatus)}
                />
                <span className={styles.infoStatus}>
                  {status(cycleDetail.chargeStatus)}
                </span>
              </div>
            </div>
          </div>
          <div>
            <p className={styles.sectionSubTitle}>
              {cycleDetail.sterilizerName} - {cycleDetail.methodName}
            </p>
          </div>
          {/* {(cycleDetail.chargeStatus === 9 || cycleDetail.chargeStatus === 10) && <div>
            <p className={styles.sectionSubTitle}>
              {`${t("BlankEntry145")} ${cycleDetail.observations}`}
            </p>
          </div>} */}
          <div className={styles.headerDetails}>
            <div>
              <div className={styles.detailItem}>
                <IoReload className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("StartedSpan") || "Started"}:{" "}
                  <span className={styles.info}>
                    {df(cycleDetail.cicleStartDate, "dateTime")}
                  </span>
                  {}
                </p>
              </div>
              <div className={styles.detailItem}>
                <IoReload className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("FinishedSpan") || "Finished"}:{" "}
                  <span className={styles.info}>
                    {df(cycleDetail.cicleFinishDate, "dateTime")}
                  </span>
                </p>
              </div>
            </div>

            <div>
              <div className={styles.detailItem}>
                <PersonIcon className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("OperatorSpan") || "User"}:{" "}
                  <span className={styles.info}>{cycleDetail.operator}</span>
                </p>
              </div>
              <div className={styles.detailItem}>
                <TiDocumentText className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("UsedProgramSpan") || "Used Program"}:{" "}
                  <span className={styles.info}>{cycleDetail.usedProgram}</span>
                </p>
              </div>
            </div>

            <div>
              <div className={styles.detailItem}>
                <FaTemperatureHigh className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("TemperatureSpan") || "Temperature"}:{" "}
                  <span className={styles.info}>
                    {cycleDetail.cicleTemperature &&
                      cycleDetail.cicleTemperature +
                        " " +
                        cycleDetail.temperatureUnit}
                  </span>
                </p>
              </div>
              <div className={styles.detailItem}>
                <CiTimer className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("TimeSpan") || "Time"}:{" "}
                  <span className={styles.info}>
                    {cycleDetail.cicleTime &&
                      cycleDetail.cicleTime + " " + cycleDetail.timeUnit}
                  </span>
                </p>
              </div>
            </div>
          </div>
         <ObservationCard
            chargeMovements={cycleDetail.chargeMovements}
            cycleMovements={cycleDetail.cycleMovements}
            />
        </div>
        <div className={styles.containerAbajo}>
          <div className={styles.containerLeft}>
            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>{t("IndicatorSpan")}</h2>
              <div className={styles.imageTitleContainer}>
                <img
                  src={biologicalImg}
                  alt="biologicalIndicator"
                  className={styles.image}
                />
                <h2 className={styles.sectionSubTitle}>
                  {t("BiologicalIndicatorSpan")}
                </h2>
              </div>
              <div className={styles.indicatorGeneral}>
                {cycleDetail.indicators &&
                cycleDetail.indicators.filter((i) =>
                  i.indicator.name.toUpperCase().includes("BT")
                ).length === 0 ? (
                  <div className={styles.noDataMessage}>
                    {t("NoBiologicalIndicatorSpan")}
                  </div>
                ) : (
                  cycleDetail.indicators &&
                  cycleDetail.indicators
                    .filter((i) =>
                      i.indicator.name.toUpperCase().includes("BT")
                    )
                    .map((i) => (
                      <div className={styles.indicatorGeneral2}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            marginBottom: "20px",
                          }}
                        >
                          {i.pcD_Group ? (
                            <div className={styles.indicatorItem2}>
                              <IndicatorLabel
                                zone={i.indicatorModelArea.description}
                                readingBiId={i.readingBi?.id}
                                backgroundColor={"white"}
                                name={i.indicator.name}
                                lot={i.lot}
                                serial={i.serial}
                                expirationDate={i.indicatorExpirationDate}
                                key={i.id}
                                border={true}
                                resultBiologic={i.readingBi?.result}
                                pcd={`${i.pcdName} - ${i.pcdLot}`}
                              />
                            </div>
                          ) : (
                            <div className={styles.indicatorItem2}>
                              <IndicatorLabel
                                zone={i.indicatorModelArea.description}
                                readingBiId={i.readingBi?.id}
                                backgroundColor={"white"}
                                name={i.indicator.name}
                                lot={i.lot}
                                serial={i.serial}
                                expirationDate={i.indicatorExpirationDate}
                                key={i.id}
                                border={true}
                                resultBiologic={i.readingBi?.result}
                              />
                            </div>
                          )}

                          <div className={styles.detailsBox}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "10px",
                              }}
                            >
                              <p>{i.readingBi?.incubator?.toString || ""}</p>
                            </div>
                            {Object.keys(i.readingBi || {}).length === 0 ? (
                              <span>{t("WithoutReadingSpan")}</span>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <span>
                                  {t("ReadingNumber") || "Record number"}:{" "}
                                  {i.readingBi?.readNumber}
                                </span>
                                <span>
                                  {t("PositionSpan") || "Position number"}:{" "}
                                  {i.readingBi?.positionNumber}
                                </span>
                                <span>
                                  {t("StartDateSpan") || "Start date"}:{" "}
                                  {df(i.readingBi?.startedTime, "dateTime")}
                                </span>
                                <span>
                                  {t("ResultDateSpan") || "Result date"}:{" "}
                                  {df(i.readingBi?.resultDate, "dateTime")}
                                </span>
                                <span>
                                  {t("AverageTemperatureSpan") ||
                                    "Average temperature"}
                                  : {i.readingBi?.averageTemperatureFormat}
                                </span>
                                <span>
                                  {t("TicketNumberSpan") || "Ticket number"}:{" "}
                                  {i.readingBi?.ticketNumber}
                                </span>
                                  <span>
                                  {t("incubator") || "Incubator"}:{" "}
                                  {i.readingBi?.incubatorName}{" "}
                                  0{i.readingBi.serial}{" "}
                                  {i.readingBi?.lot}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))
                )}
              </div>

              <div className={styles.imageTitleContainer}>
                <img
                  src={chemicalImg}
                  alt="chemicalIndicator"
                  className={styles.image}
                />
                <h2 className={styles.sectionSubTitle}>
                  {" "}
                  {t("ChemicalIndicatorSpan")}
                </h2>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                }}
              >
                <div className={styles.indicatorGeneral}>
                  {cycleDetail.indicators &&
                  cycleDetail.indicators.filter(
                    (i) => !i.indicator.name.toUpperCase().includes("BT")
                  ).length === 0 ? (
                    <div className={styles.noDataMessage}>
                      {t("NoChemicalIndicatorSpan")}
                    </div>
                  ) : (
                    cycleDetail.indicators &&
                    cycleDetail.indicators
                      .filter(
                        (i) => !i.indicator.name.toUpperCase().includes("BT")
                      )
                      .map((indicator) => (
                        <div className={styles.indicatorGeneral2}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              marginBottom: "20px",
                            }}
                          >
                            {indicator.pcD_Group ? (
                              <div className={styles.indicatorItem2}>
                                <IndicatorLabel
                                  zone={
                                    indicator.indicatorModelArea.description
                                  }
                                  readingBiId={
                                    indicator.readingCheSterilizer?.id
                                  }
                                  isChemical={true}
                                  backgroundColor={"white"}
                                  name={indicator.indicator.name}
                                  lot={indicator.lot}
                                  serial={indicator.serial}
                                  // quantity={indicator.quantity}
                                  expirationDate={
                                    indicator.indicatorExpirationDate
                                  }
                                  border={true}
                                  resultCH={
                                    indicator.readingCheSterilizer?.result
                                  }
                                  userResultCH={
                                    indicator.readingCheSterilizer?.visualResult
                                  }
                                  pcd={`${indicator.pcdName} - ${indicator.pcdLot}`}
                                />
                              </div>
                            ) : (
                              <div className={styles.indicatorItem2}>
                                <IndicatorLabel
                                  zone={
                                    indicator.indicatorModelArea.description
                                  }
                                  readingBiId={
                                    indicator.readingCheSterilizer?.id
                                  }
                                  isChemical={true}
                                  backgroundColor={"white"}
                                  name={indicator.indicator.name}
                                  lot={indicator.lot}
                                  serial={indicator.serial}
                                  // quantity={indicator.quantity}
                                  expirationDate={
                                    indicator.indicatorExpirationDate
                                  }
                                  border={true}
                                  resultCH={
                                    indicator.readingCheSterilizer?.result
                                  }
                                  userResultCH={
                                    indicator.readingCheSterilizer?.visualResult
                                  }
                                />
                              </div>
                            )}

                            <div className={styles.detailsBox}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  marginBottom: "10px",
                                }}
                              ></div>
                              {Object.keys(indicator.readingCheSterilizer || {})
                                .length === 0 ? (
                                <span>{t("WithoutReadingSpan")}</span>
                              ) : (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    overflowWrap: "break-word",
                                    width: "250px",
                                  }}
                                >
                                  <span>
                                    {t("ReadingNumber") || "Record number"}:{" "}
                                    {indicator.readingCheSterilizer?.readNumber}
                                  </span>
                                  <span>
                                    {t("DateSpan") || "Date"}:{" "}
                                    {df(
                                      indicator.readingCheSterilizer
                                        ?.creationTest,
                                      "dateTime"
                                    )}
                                  </span>
                                  <span>
                                    {t("ObservationSpan") || "Observations"}:{" "}
                                    {indicator.readingCheSterilizer?.notes}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))
                  )}
                </div>
              </div>
            </section>
            <section>
              <div className={styles.imageTitleContainer}>
                <img
                  src={materialImg}
                  alt="Materials"
                  className={styles.image}
                />
                <h2 className={styles.sectionTitle}>{t("MaterialsSpan")}</h2>
              </div>
              {cycleDetail.packages && cycleDetail.packages.length === 0 ? (
                <p className={styles.noDataMessage}>
                  {t("WithoutPackageMaterialSpan")}.
                </p>
              ) : (
                <div className={styles.tableContainer}>
                  {cycleDetail.packages &&
                    cycleDetail.packages.map((pkgObj) => {
                      const pkg = pkgObj.package; // Accede al objeto `package` dentro de cada `packages`
                      return (
                        <div className={styles.packageSection}>
                          <div>
                            <h3
                              className={styles.packageTitle}
                              onClick={() => toggleOpen(pkg.id)}
                            >
                              {pkg.packageNumber} - {pkg.description}{" "}
                              {pkg.packageStatus > 4 && (
                                <span
                                  className={`${styles.packageStatus} ${
                                    pkg.packageStatus === 7
                                      ? styles.backgroundRed
                                      : styles.backgroundOrange
                                  }`}
                                >
                                  {statusPackage(pkg.packageStatus)}
                                </span>
                              )}
                              {openSections[pkg.id] ? (
                                <IoIosArrowUp className={styles.arrowIcon} />
                              ) : (
                                <IoIosArrowDown className={styles.arrowIcon} />
                              )}
                            </h3>
                            {openSections[pkg.id] && (
                              <div className={styles.additionalContent}>
                                <h2 className={styles.sectionTitle}>
                                  {t("IndicatorSpan")}
                                </h2>
                                <div className={styles.indicatorGeneral}>
                                  {pkg.indicators &&
                                  pkg.indicators.length === 0 ? (
                                    <p className={styles.noDataMessage}>
                                      {t("NoIndicatorsSpan")}
                                    </p>
                                  ) : (
                                    pkg.indicators &&
                                    pkg.indicators.map((indicator) => (
                                      <div
                                        className={styles.indicatorItemChemical}
                                        key={indicator.id}
                                      >
                                        {indicator.readingCheSterilizer ? (
                                          <Tooltip
                                            key={indicator.id}
                                            title={
                                              <div>
                                                <div>
                                                  {t("ReadingNumber")}:{" "}
                                                  {
                                                    indicator
                                                      .readingCheSterilizer
                                                      ?.readNumber
                                                  }
                                                </div>
                                                <div>
                                                  {t("DateSpan")}:{" "}
                                                  {df(
                                                    indicator
                                                      .readingCheSterilizer
                                                      ?.creationTest,
                                                    "dateTime"
                                                  )}
                                                </div>
                                                <div>
                                                  {t("ObservationSpan")}:{" "}
                                                  {
                                                    indicator
                                                      .readingCheSterilizer
                                                      ?.notes
                                                  }
                                                </div>
                                              </div>
                                            }
                                            arrow
                                          >
                                            <div
                                              className={styles.indicatorItem}
                                            >
                                              <IndicatorLabel
                                                readingBiId={
                                                  indicator.readingCheSterilizer
                                                    ?.id
                                                }
                                                isChemical={true}
                                                backgroundColor={"white"}
                                                name={indicator.indicator.name}
                                                lot={indicator.lot}
                                                serial={indicator.serial}
                                                expirationDate={
                                                  indicator.expirationDate
                                                }
                                                border={true}
                                                resultCH={
                                                  indicator.readingCheSterilizer
                                                    .result
                                                }
                                                userResultCH={
                                                  indicator.readingCheSterilizer
                                                    .visualResult
                                                }
                                              />
                                            </div>
                                          </Tooltip>
                                        ) : (
                                          <div className={styles.indicatorItem}>
                                            <Tooltip
                                              key={indicator.id}
                                              title={
                                                <div>
                                                  <div>
                                                    {t("ProductSpan")}:{" "}
                                                    {indicator.indicator.name}
                                                  </div>
                                                  <div>
                                                    {t("LotSpan")}:{" "}
                                                    {indicator.lot}
                                                  </div>
                                                  {indicator.serial && (
                                                    <div>
                                                      {t("SerialSpan")}:{" "}
                                                      {indicator.serial}
                                                    </div>
                                                  )}
                                                  {/* Renderizar información de readingBI si existe */}
                                                  {indicator.readingBI && (
                                                    <div>
                                                      <div>Incubator:</div>
                                                      <div>
                                                        {t("PositionSpan")}:{" "}
                                                        {
                                                          indicator.readingBI
                                                            .positionNumber
                                                        }
                                                      </div>
                                                      <div>
                                                        {t("StatusSpan")}:{" "}
                                                        {
                                                          indicator.readingBI
                                                            .statusDescription
                                                        }
                                                      </div>
                                                      <div>
                                                        {t("ReadingNumber")}:{" "}
                                                        {
                                                          indicator.readingBI
                                                            .readNumber
                                                        }
                                                      </div>
                                                      <div>
                                                        {t("ResultSpan")}:{" "}
                                                        {getResultText(
                                                          indicator.readingBI
                                                            .result
                                                        )}
                                                      </div>
                                                      <div>
                                                        {t("StartSpan")}:{" "}
                                                        {df(
                                                          indicator.readingBI
                                                            .startedTime,
                                                          "dateTime"
                                                        )}
                                                      </div>
                                                      <div>
                                                        {t("FinishSpan")}:{" "}
                                                        {df(
                                                          indicator.readingBI
                                                            .resultDate,
                                                          "dateTime"
                                                        )}
                                                      </div>
                                                      <div>
                                                        {t(
                                                          "IncubationTimeSpan"
                                                        )}
                                                        :{" "}
                                                        {minutesToHourFormat(
                                                          indicator.readingBI
                                                            .incubationTime
                                                        )}
                                                      </div>
                                                      {indicator.readingBI
                                                        .program?.nombre && (
                                                        <div>
                                                          Program:{" "}
                                                          {
                                                            indicator.readingBI
                                                              .program.nombre
                                                          }
                                                        </div>
                                                      )}
                                                    </div>
                                                  )}
                                                </div>
                                              }
                                              arrow
                                            >
                                              <div
                                                className={styles.indicatorItem}
                                              >
                                                <IndicatorLabel
                                                  name={
                                                    indicator.indicator.name
                                                  }
                                                  lot={indicator.lot}
                                                  serial={indicator.serial}
                                                  expirationDate={
                                                    indicator.expirationDate
                                                  }
                                                  backgroundColor={"white"}
                                                  border={true}
                                                  resultBiologic={
                                                    indicator.readingBI?.result
                                                  }
                                                  detail={true}
                                                />
                                              </div>
                                            </Tooltip>
                                          </div>
                                        )}
                                      </div>
                                    ))
                                  )}
                                </div>

                                <div className={styles.observationSection2}>
                                  <p className={`${styles.observationTitle2}`}>
                                    Observation
                                  </p>
                                  <div className={styles.observationContainer2}>
                                    {pkg.observations ? (
                                      <p className={styles.observation2}>
                                        {pkg.observations}
                                      </p>
                                    ) : (
                                      <p className={styles.observation2}>
                                        {t("NoObservationSpan")}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                          <table className={styles.dataTable}>
                            <thead>
                              <tr>
                                <th className={styles.th}>
                                  {t("MaterialSpan")}
                                </th>
                                <th className={styles.th}>
                                  {t("TypeOfMaterialSpan")}
                                </th>
                                <th className={styles.th}>
                                  {t("QuantitySpan")}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {pkg.materials && pkg.materials.length > 0 ? (
                                pkg.materials.map((materialObj, index) => {
                                  const material = materialObj.material; // Accede al objeto material

                                  if (!material) {
                                    return null;
                                  }

                                  return (
                                    <tr
                                      key={material.materialId || index}
                                      className={styles.trHover}
                                    >
                                      <td className={styles.td}>
                                        {" "}
                                        {material.name ||
                                          "Nombre no disponible"}
                                        {material.serial && (
                                          <div className={styles.serial}>
                                            {t("SerialSpan")}: {material.serial}
                                          </div>
                                        )}
                                      </td>
                                      <td className={styles.td}>
                                        {material.materialType.name || "N/A"}
                                      </td>
                                      <td className={styles.td}>
                                        {materialObj.quantity || 0}
                                      </td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td colSpan="3" className={styles.td}>
                                    {t("NoMaterialSpan")}{" "}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      );
                    })}
                </div>
              )}
            </section>
          </div>
          <div className={styles.containerRight}>
            <section>
              <h2 className={styles.titleImage}>{t("ImageSpan")}</h2>

              {cycleDetail.ticketSterilizer ? (
                <div className={styles.imgContainer}>
                  <img
                    src={cycleDetail.ticketSterilizer}
                    alt="No available"
                    className={styles.ticketImage}
                    onClick={handleImageClick}
                    crossOrigin="anonymous"
                  />
                </div>
              ) : (
                <div className={styles.imgContainer2}>
                  <h2 className={styles.titleImage}>
                    {t("BlankEntry12") || "The ticket wasn't loaded"}
                  </h2>
                </div>
              )}
              {isModalOpen && (
                <ImageModal
                  imageSrc={cycleDetail.ticketSterilizer}
                  onClose={handleCloseModal}
                />
              )}
            </section>
          </div>
        </div>
        <div>
          <ModalLoading open={modalLoading} />
          {showReport && (
            <ReportModal
              htmlContent={report}
              onClose={handleCloseModalReport}
            />
          )}
        </div>
      </div>
      <ButtonQ onClick={generatePDF}>{t("DownloadAsPDF")}</ButtonQ>
    </PageContainer>
  );
}
